module.exports = __webpack_public_path__ + "media/images/four-8440b2a4dcf15277e23a4edb67313920.svg";